import React from "react";
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
//import { format } from "d3-format"
import CircleIcon from '@mui/icons-material/Circle';
import CvdMikroCardssmall from "../../../../../components/Cards/CVDMikroCards_small";
import DiaTextInsulin from "../InfoText/DiaTextInsulin";





export default function InsulinCard() {

return (
<>
<CvdMikroCardssmall  
  
content = {<>      
<Grid container >  

<Grid item xs={12} >
       
<Grid container> 
          <Grid item xs={11}>  <Typography variant="h3" color='common.white' sx={{p:1}}> INSULINE  </Typography>   </Grid>
          <Grid item xs={1}>   <DiaTextInsulin />   </Grid>
       </Grid>
                    
       <Grid item xs={12} sx={{ p:1,  }} >
    
            <Typography variant="h3" color='primary.light' 
                        sx={{mt: 1, fontFamily: 'Poppins', fontWeight: '400', fontSize: {sx: '55%', sm: '45%', md: '175%', lg: '180%', xl: '260%' },
                                
                            color: 'traffic.orange', 
                        //      ...(gutheart_composition < micro_warning_low && {color: 'traffic.orange'}), 
                        //      ...(gutheart_composition < micro_warning_red && {color: 'traffic.red'}), 
                                }}> 
                    
                    INS&nbsp;<Typography component="span" variant="body1"> dysbalance </Typography><br />
                        
            </Typography>
    </Grid>

    <Grid item xs={12} sx={{ pl:1 }} > 
            <Typography variant='h6 'sx={{ color: 'common.white', fontFamily: 'Poppins', fontWeight: '200', fontSize: '0.8rem'}} >
            Reference:  &nbsp;  Species Composition
        </Typography>
    </Grid>

    <Grid item xs={12} sx={{ mt:4}}>
            <Typography variant="h6" color='common.white' sx={{p:1, fontWeight: '600', fontSize: {sx: '55%', sm: '45%', md: '75%', lg: '90%', xl: '95%' },    }}>
            ANALYSIS: &nbsp; INSULINE
            </Typography> 
    </Grid>

    <Typography variant="h6" color='common.white' sx={{p:2, fontWeight: '400', fontSize: {sx: '55%', sm: '45%', md: '75%', lg: '90%', xl: '90%' },    }}> 
                        <Grid container sx={{alignItems: 'center', justifyContent: 'center'}}>
                            <Grid item xs={6} >                           
                            Bacteroides<br />
                            Betaproteobacteria<br />
                            Collinsella<br />
                            Eggerthella<br />
                            Lactobacillaceae<br />
                            Ruminococcus<br />
                            Veillonella<br />
                            Bifidobacterium<br />
                            Blautia<br />
                            Butyricimonas<br />
                            Erysipelotrichaceae<br />
                            Firmicutes<br />
                            Lachnospiraceae<br />
                            Megamonas<br />
                            Roseburia


                            </Grid>
                            <Grid item xs={2} > 
                            <CircleIcon sx={{fontSize: '110%', color: 'traffic.red', }}></CircleIcon><br />
                            <CircleIcon sx={{fontSize: '110%', color: 'traffic.red', }}></CircleIcon><br />
                            <CircleIcon sx={{fontSize: '110%', color: 'traffic.green', }}></CircleIcon><br />
                            <CircleIcon sx={{fontSize: '110%', color: 'traffic.green', }}></CircleIcon><br />
                            <CircleIcon sx={{fontSize: '110%', color: 'traffic.green', }}></CircleIcon><br />
                            <CircleIcon sx={{fontSize: '110%', color: 'traffic.green', }}></CircleIcon><br />
                            <CircleIcon sx={{fontSize: '110%', color: 'traffic.green', }}></CircleIcon><br />
                            <CircleIcon sx={{fontSize: '110%', color: 'traffic.green', }}></CircleIcon><br />
                            <CircleIcon sx={{fontSize: '110%', color: 'traffic.green', }}></CircleIcon><br />
                            <CircleIcon sx={{fontSize: '110%', color: 'traffic.green', }}></CircleIcon><br />
                            <CircleIcon sx={{fontSize: '110%', color: 'traffic.green', }}></CircleIcon><br />
                            <CircleIcon sx={{fontSize: '110%', color: 'traffic.green', }}></CircleIcon><br />  
                            <CircleIcon sx={{fontSize: '110%', color: 'traffic.green', }}></CircleIcon><br /> 
                            <CircleIcon sx={{fontSize: '110%', color: 'traffic.green', }}></CircleIcon><br /> 
                            <CircleIcon sx={{fontSize: '110%', color: 'traffic.green', }}></CircleIcon><br />                  
                                    
                            </Grid>
                        </Grid>
             </Typography>
            </Grid>

        </Grid>
 
           
    </>}   
    />    
</>
)};
  